import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import SecondaryButton from "../Buttons/SecondaryButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import "./styles/F2FModal.scss"

import CloseIcon from "../../images/icons/close_icon.svg?react";
import CheckIcon from "../../images_new/icon/check.svg?react";
import WarningIcon from "../../images_new/clarity_warning-standard-solid.svg?react";


const F2FCameraPermisionModal = ({ handleEndCall, isCallAccepted, isOpen, setIsCallPermissionModalOpen, message, handleTryAgain }) => {
    return (
        <>
            <div style={{ backgroundColor: "transparent" }}>
                <Modal
                    className={`f2f-calling-modal`}
                    size="md"
                    show={isOpen}
                >
                    <div className='f2f-calling-modal-content'>
                        <Modal.Body className='f2f-calling-modal-content'>
                            <Row className="call-extnd-row" >
                                <Col xs={12} className="call-extnd-warning-icon">
                                    <WarningIcon />
                                </Col>
                            </Row>
                            <Row className="call-extnd-row">
                                <Col xs={12} className="call-extnd-warning-icon">
                                    <h2 style={{ width: "100%" }}>Warning!!!</h2>

                                    <div><p>{message || 'Camera & Microphone permission is required'}</p></div>
                                </Col>
                            </Row>
                            <Row className="call-extnd-row" >
                                <Col xs={12} md={6} className="f2f-package-close-icon ps-0">
                                    <SecondaryButton
                                        title={isCallAccepted ? "Leave Call" : "Cancel"}
                                        startIcon={CloseIcon}
                                        className=' text-center call-extnd-req-btn call-extnd-dec-btn mb-4 mb-md-0'
                                        onClick={() => {
                                            if (isCallAccepted) {
                                                handleEndCall();
                                            } else {
                                                setIsCallPermissionModalOpen({
                                                    isOpen: false,
                                                    message: null
                                                })
                                            }
                                        }}
                                    />
                                </Col>
                                <Col xs={12} md={6} className="f2f-package-close-icon ps-0" >
                                    <PrimaryButton
                                        title="Grant Permission "
                                        startIcon={CheckIcon}
                                        className='call-extnd-req-btn call-extnd-dec-bt'
                                        onClick={handleTryAgain}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                    </div>
                </Modal>
            </div>
        </>
    );
};

export default F2FCameraPermisionModal;
